<template>
  <div >

    <div class="loading-container center" v-if="loadingItens">
      <rotate-square class="loading-position center" size="45px" />
    </div>

    <b-card v-for="componente in componentes" :key="componente.cliente" :title="componente.cliente" v-if="!loadingItens">
      <b-row>
        <b-col v-for="card in componente.cards" :key="card.titulo" class="col-sm-12 col-md-4 col-lg-4">
          <b-card class="custom-card" :title="card.titulo" :bg-variant="SetCor(card.cor)">
            <CustomCard :chartId="card.titulo" :datasetsGraf="card.valor" :quantidade="card.quantidade" />
          </b-card>
        </b-col>
      </b-row>
    </b-card>


  </div>
</template>

<script>
import { RotateSquare } from "vue-loading-spinner";
import CustomCard from "../base/components/CustomCards"


export default {
  name: 'DashboardT',
  components: { RotateSquare,CustomCard},
  data(){
      return {
        PerfilUsuarioLogado: this.$store.getters.getAutenticacao.perfil,
        componentes:[],
      }
    },
  created() {
         if(this.PerfilUsuarioLogado == 4)
            this.$router.push('/pesagem')

            this.GetDashboard();
      },
      methods: {
        SetCor(inCor) {
          let outCor = "";
            switch (inCor) {
              case 1:
                outCor = "warning";
                break;
              case 2:
                outCor = "primary";
                break;
              case 3:
                outCor = "info";
                break;
              case 4:
                outCor = "danger";
                break;
              case 5:
                outCor = "success";
                break;
              default:
                outCor = "Default";
                break;
                  }
                
                return outCor;
        },
        GetDashboard(){
          var vm = this
        vm.loadingItens = true
        this.$http({url: '/pesagem/dashboard/' + vm.$store.getters.getAutenticacao.contaId + "/" + vm.$store.getters.getAutenticacao.clienteId, method: 'GET' })
          .then(response => {
            vm.loadingItens=false
            vm.componentes =  response.data;

        })
        .catch(err => {
            alert(err.message)
        })
        }
      }
}
</script>

<style lang="scss" scoped>

.custom-card {
  box-shadow: 0 0.2rem 0.8rem rgba(0, 0, 0, 0.2);
  max-height: 130px;
}
</style>